import React, { useEffect, useRef } from "react"
import { Helmet } from "react-helmet"
import { graphql, Link } from "gatsby"
import Layout from "../../components/Layout"
import "./JobPage.scss"
import Breadcrumb from "../../components/Breadcrumb"
// import jobsImage from "../../images/docs/docs-og.jpg" //FIXME
// import jobsImageTW from "../../images/docs/docs-og-tw.jpg" //FIXME

const scriptURL = "https://boards.greenhouse.io/embed/job_board/js?for=ionq"

export const query = graphql`
  query ($gh_Id: Float!) {
    greenhouseJob(gh_Id: { eq: $gh_Id }) {
      title
      absolute_url
      location {
        name
      }
      departments {
        name
      }
      content
      fields {
        escapedContent
      }
      updated_at
      gh_Id
      id
    }
  }
`

const JobPage = ({ data, location }) => {
  const {
    title: headline,
    fields: { escapedContent },
    gh_Id,
    location: jobLocation,
    departments: jobTeams,
  } = data.greenhouseJob

  let ghSrc = useRef()
  useEffect(() => {
    if (window) {
      ghSrc.current = new URL(location.href).searchParams.get("gh_src")
    }
  })

  const handleChangeClientState = (_newState, addedTags) => {
    if (addedTags && addedTags.scriptTags) {
      const foundScript = addedTags.scriptTags.find(
        ({ src }) => src === scriptURL
      )
      if (foundScript) {
        foundScript.addEventListener("load", () => {
          //loaded
          window.Grnhse.Iframe.load(gh_Id, ghSrc.current)
        })
      }
    }
  }

  const html = escapedContent
    .replace(/<ul/g, `<ul class="job-content-list"`)
    .replace(/<p/g, `<p class="job-content-paragraph"`)
    .replace(/<p class="job-content-paragraph">&nbsp;<\/p >/g, "")
    .replace(/<br>& nbsp;<br>/g, `</p> <p class="job-content-paragraph">`)

  return (
    <Layout
      id="job-page"
      className="JobPage"
      title={`IonQ Jobs: ${headline}`}
      location={location}
      // image={jobsImage}
      // twitterImage={jobsImageTW}
      description={`IonQ is hiring a ${headline}. Make History. Build the future of computing. Apply online today.`}
    >
      <div id="grnhse_app" className="greenhouse-application"></div>
      <div className="return-to-jobs">
        <Link className="return-link" to="/careers#open-positions">
          back to all jobs
        </Link>
      </div>
      <Helmet onChangeClientState={handleChangeClientState}>
        {typeof window !== "undefined" &&
          typeof window.Grnhse === "undefined" && (
            <script async defer src={scriptURL} />
          )}
      </Helmet>
    </Layout>
  )
}

export default JobPage
